import { useParams } from 'react-router-dom'

import { Post } from '@tribeplatform/react-components/Post'
import { ReplyList } from '@tribeplatform/react-components/Reply'
import { usePost } from '@tribeplatform/react-sdk/hooks'

import { useQuery } from '../../hooks/useQuery.js'
import { EmbedProvider } from '../EmbedProvider.js'
import { withEmbedRouteChangeHandler } from '../withEmbedRouteChangeHandler.js'

export const PostEmbed = withEmbedRouteChangeHandler(() => {
  const params = useParams()
  const query = useQuery()
  const { id: postId } = params
  const { data: post } = usePost({
    variables: {
      id: postId,
    },
  })
  const {
    style = 'card',
    view = 'all',
    show_full_content: collapsible,
    readonly: readonlyQuery = 'false',
  } = query || {}

  let replyBar = true
  let showContent = true

  if (view === 'replies-only') {
    showContent = false
  } else if (view === 'content-only') {
    replyBar = false
  }
  const _view = style === 'row' ? 'row' : 'card'
  const _collapsible = collapsible !== 'true'

  const readonly = readonlyQuery === 'true'
  const values = {
    readonly,
    postView: _view,
    showContent,
    // we want to use ReplyList so we hard-code this to false
    replyBar: false,
    collapsible: _collapsible,
  }

  return (
    <EmbedProvider values={values}>
      {view !== 'replies-only' && post && (
        <Post context="embed" post={post} replyBar={false} />
      )}
      {post?.repliesCount > 0 && replyBar && (
        <ReplyList
          post={post}
          readonly={readonly}
          isReplyBarSticky
          stickyFooterClassName="mt-5"
        />
      )}
    </EmbedProvider>
  )
})
